module.exports = __webpack_public_path__ + "static/lutron-pro-logo-e4d6c80e7fabef2cd81d076db9b66b50.png";